import { render, staticRenderFns } from "./OverlayImages.vue?vue&type=template&id=e13bc48a&scoped=true&lang=pug"
import script from "./OverlayImages.vue?vue&type=script&lang=js"
export * from "./OverlayImages.vue?vue&type=script&lang=js"
import style0 from "./OverlayImages.vue?vue&type=style&index=0&id=e13bc48a&prod&lang=sass&nolang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13bc48a",
  null
  
)

export default component.exports